import { useParams } from "react-router";
import { useGetBeforeAndAfterProjectQuery } from "../../../hooks/use-get-before-and-after-project-query";
import { useEffect, useState } from "react";
import BeforeAfterProjectManager from "../../before-after-project-manager";

export const AddBeforeAndAfterView = () => {
  const params = useParams();
  const isEditMode = !!params?.id;
  const { getBeforeAndAfterProject, loading } =
    useGetBeforeAndAfterProjectQuery();
  const [project, setProject] = useState<any>(null);

  useEffect(() => {
    if (!isEditMode || !params.id) {
      setProject(null);
      return;
    }

    let isCancelled = false;

    getBeforeAndAfterProject(params.id as string, true)
      .then((data) => {
        if (isCancelled || !data) return;

        // Transform the data to match the new system format
        const transformedData = {
          _id: data._id,
          name: data.name || "",
          description: data.description || "",
          style: data.style || null,
          projectCategory: data.projectCategory || null,
          budgetRange: data.budgetRange || null,
          squareFootage: data.squareFootage || null,
          projectDuration: data.projectDuration || null,
          specialRequirements: data.specialRequirements || [],
          published: data.published ?? null,
          storyTitle: data.storyTitle || "",
          storySubtitle: data.storySubtitle || "",
          introduction: data.introduction || "",
          challenges: data.challenges || "",
          wishList: data.wishList || [],
          overview: data.overview || "",
          additionalSections: data.additionalSections || [],
          beforeImages: data.beforeImages || [],
          afterImages: data.afterImages || [],
          coverImage: data.coverImage || null,
        };
        setProject(transformedData);
      })
      .catch((error) => {
        if (!isCancelled) {
          console.error("Error fetching project file:", error);
        }
      });

    return () => {
      isCancelled = true;
    };
  }, [isEditMode, params.id, getBeforeAndAfterProject]);

  if (isEditMode && loading) {
    return <div>Loading...</div>;
  }

  return (
    <BeforeAfterProjectManager
      project={project}
      isEditMode={isEditMode}
    />
  );
};
